<template>
  <div>
    <Header
      v-if="!this.$store.getters.iframeColidee"
      :window="window"
      :parameters="'adminLinks'"
    />
    <LinkList />
    <Footer v-if="!this.$store.getters.iframeColidee" :window="window" />
  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import LinkList from "@/components/link/LinkList";

export default {
  components: {
    Header,
    Footer,
    LinkList
  },
  data() {
    return {
      window: {
        width: window.innerWidth
      }
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/page/AdminLinks.vue